import(/* webpackMode: "eager" */ "/home/runner/work/common-wealth-pwa/common-wealth-pwa/src/app/(page)/funds/[fundId]/layout.tsx");
